import React from 'react';
import Grid from '@material-ui/core/Grid';
import {Styles} from '../../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import {Translate} from "../../../../config/Translate";
import { withSnackbar } from 'notistack';
import BreadCrumbs from "../../../components/elements/BreadCrumbs";
import AppAnimate from "../../../components/AppAnimate";
import AppCard from "../../../components/layouts/components/AppCard";
import ShopDiscounts from "./ShopDiscounts";
import {withRouter} from "react-router-dom";
import {connect} from "trim-redux";


class ShopDiscountsPage extends React.Component {
    classes = this.props.classes;
    render(){
        let {user} = this.props;
        let shop_id = !!user.shops ? !!user.shops[0] ? user.shops[0].id : 0 : 0;
        return (
            <AppAnimate animation='transition.slideUpIn' delay={200} title={Translate.shopDiscounts}>
                <Grid container spacing={2} justify="center">
                    <Grid item xs={12}>
                        <AppCard
                            title={ Translate.shopDiscounts}
                            action={
                                <BreadCrumbs singleLevel firstText={Translate.shopDiscounts}/>
                            }>
                            <ShopDiscounts shop_id={shop_id}/>
                        </AppCard>
                    </Grid>
                </Grid>
            </AppAnimate>
        );
    }
}
const mstp = state => ({
    isAuth: state.isAuth,
    user: state.user,
    primary_shop: state.primary_shop,

});
export default withRouter(withSnackbar(withStyles(Styles)(connect(mstp)(ShopDiscountsPage))));
